import { AnyAction } from 'redux';

import { SET_CONTEXT_MENU } from './constants';

export const initialState = {
  contextMenu: undefined,
};

export const contextMenuReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case SET_CONTEXT_MENU:
      return { ...state, contextMenu: action.contextMenu };
    default:
      return state;
  }
};
